import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';

@Injectable({
  providedIn: 'root'
})
export class InternalStockAllocationService extends BaseApiTemplateService<GenericDocContainerModel> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-stock-allocation';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-stock-allocation';
    this.httpClient = http;
  }

  // public printPdf(guid: string, templateDocId: string, printServiceClassName: string, apiVisa: ApiVisa): Observable<Blob> {
  //   return this.httpClient.get<Blob>(
  //     this.apiUrl + '/print-pdf/' + guid,
  //     {
    //fsdfdsaf
  //       headers: new HttpHeaders({
  //         authorization: apiVisa.jwt_secret,
  //         responseType: 'blob',
  //         tenantCode: apiVisa.tenantCode
  //       }),
  //       params: new HttpParams()
  //         .set('templateDocId', templateDocId)
  //         .set('printServiceClassName', printServiceClassName),
  //       responseType: 'blob' as 'json'
  //     }
  //    );
  // }
}
